import { Person } from '@shared/assets';
import type { EventCoach } from '@src/library/models/events';
import * as st from './styles.module.scss';

interface Props {
  presenters: EventCoach[];
}

export const Presenter = ({ presenters }: Props): JSX.Element => {
  const title = presenters.length === 1 ? 'Ведущий' : 'Ведущие';

  return (
    <section className={st.wrap}>
      <h3>{title}</h3>
      <ul className={st.list}>
        {presenters.map((presenter) => (
          <div className={st.presenter} key={presenter.id}>
            <div className={st.presenter__left}>
              {presenter.photo ? (
                <figure>
                  <img src={presenter.photo} />
                </figure>
              ) : (
                <div className={st.personIcon}>
                  <Person />
                </div>
              )}
            </div>
            <h4>{`${presenter.first_name} ${presenter?.second_name ?? ''} ${presenter.last_name}`}</h4>
            <p>{presenter.description}</p>
          </div>
        ))}
      </ul>
    </section>
  );
};
